import axios from 'axios';
import { getAuthorizationToken, getPartnerGuid } from './access.es6';
import { getEnvironmentInformation } from './utils.es6';

let EnvironmentalInformation = null;

EnvironmentalInformation = getEnvironmentInformation();

const PARTNER_CONFIGS_URL = EnvironmentalInformation
  ? EnvironmentalInformation.servicesURLs.partnerConfigs
  : 'https://partner-configs.staging.aspin-inclusivity.com/';

const PRODUCT_CONFIG_URL = EnvironmentalInformation
  ? EnvironmentalInformation.servicesURLs.productConfig
  : 'https://product-config.staging.aspin-inclusivity.com/';

const EMAIL_SERVICE_URL = EnvironmentalInformation
  ? EnvironmentalInformation.servicesURLs.emailService
  : 'https://email-service.staging.aspin-inclusivity.com/';

const SMS_TEMPLATE_URL = EnvironmentalInformation
  ? EnvironmentalInformation.servicesURLs.smsOrgTemplate
  : 'https://partner-sms-template.staging.aspin-inclusivity.com/';

const WEBHOOK_URL = EnvironmentalInformation
  ? EnvironmentalInformation.servicesURLs.webhookService
  : 'https://webhook.staging.aspin-inclusivity.com/';

const partnerConfigsInstance = axios.create({
  baseURL: PARTNER_CONFIGS_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

const productConfigInstance = axios.create({
  baseURL: PRODUCT_CONFIG_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

const emailServiceInstance = axios.create({
  baseURL: EMAIL_SERVICE_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

const smsTemplateInstance = axios.create({
  baseURL: SMS_TEMPLATE_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

const webhookInstance = axios.create({
  baseURL: WEBHOOK_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

// ─── Organizations ────────────────────────────────────────────────────────────

// export function getOrganizations() {
//   axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
//   return partnerConfigsInstance.get(`api/organizations?partner=${getPartnerGuid()}`);
// }

export function getOrganization(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.get(`api/organizations/${guid}`);
}

export function createOrganization(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.post('api/organizations', payload);
}

export function updateOrganization(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.put(`api/organizations/${guid}`, payload);
}

export function deleteOrganization(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.delete(`api/organizations/${guid}`);
}

// ─── Org Product Templates ────────────────────────────────────────────────────

export function getOrgProductTemplates(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return productConfigInstance.get(
    `api/product-templates?organization_guid=${organizationGuid}`
  );
}

export function createOrgProductTemplate(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return productConfigInstance.post('api/product-templates', payload);
}

export function updateOrgProductTemplate(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return productConfigInstance.put(`api/product-templates/${guid}`, payload);
}

export function deleteOrgProductTemplate(guid, organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return productConfigInstance.delete(
    `api/product-templates/${guid}?organization_guid=${organizationGuid}`
  );
}

// ─── Org Email Templates ──────────────────────────────────────────────────────

export function getOrgEmailTemplates(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return emailServiceInstance.get(
    `api/email_templates_org?organization_guid=${organizationGuid}`
  );
}

export function createOrgEmailTemplate(organizationGuid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return emailServiceInstance.post(
    `api/email_templates_org?organization_guid=${organizationGuid}`,
    payload
  );
}

export function updateOrgEmailTemplate(guid, organizationGuid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return emailServiceInstance.put(
    `api/email_templates_org/${guid}?organization_guid=${organizationGuid}`,
    payload
  );
}

export function deleteOrgEmailTemplate(guid, organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return emailServiceInstance.delete(
    `api/email_templates_org/${guid}?organization_guid=${organizationGuid}`
  );
}

// ─── Org SMS Templates ────────────────────────────────────────────────────────

export function getOrgSmsTemplates(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return smsTemplateInstance.get(
    `api/sms_templates_org?organization_guid=${organizationGuid}`
  );
}

export function createOrgSmsTemplate(organizationGuid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return smsTemplateInstance.post(
    `api/sms_templates_org?organization_guid=${organizationGuid}`,
    payload
  );
}

export function updateOrgSmsTemplate(guid, organizationGuid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return smsTemplateInstance.put(
    `api/sms_templates_org/${guid}?organization_guid=${organizationGuid}`,
    payload
  );
}

export function deleteOrgSmsTemplate(guid, organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return smsTemplateInstance.delete(
    `api/sms_templates_org/${guid}?organization_guid=${organizationGuid}`
  );
}

// ─── Org Webhook Templates ────────────────────────────────────────────────────

export function getOrgWebhookTemplates(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return webhookInstance.get(
    `api/webhooks_templates?organization_guid=${organizationGuid}`
  );
}

export function createOrgWebhookTemplate(organizationGuid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return webhookInstance.post(
    `api/webhooks_templates?organization_guid=${organizationGuid}`,
    payload
  );
}

export function updateOrgWebhookTemplate(guid, organizationGuid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return webhookInstance.put(
    `api/webhooks_templates/${guid}?organization_guid=${organizationGuid}`,
    payload
  );
}

export function deleteOrgWebhookTemplate(guid, organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return webhookInstance.delete(
    `api/webhooks_templates/${guid}?organization_guid=${organizationGuid}`
  );
}

// ─── Org IPP Configs ──────────────────────────────────────────────────────────

export function getOrgIppConfigs(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.get(
    `api/ipp_configs_org?organization_guid=${organizationGuid}`
  );
}

export function createOrgIppConfig(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.post('api/ipp_configs_org', payload);
}

export function updateOrgIppConfig(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.put(`api/ipp_configs_org/${guid}`, payload);
}

export function deleteOrgIppConfig(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.delete(`api/ipp_configs_org/${guid}`);
}

// ─── Org Claim Initiation Configs ─────────────────────────────────────────────

export function getOrgClaimInitConfigs(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.get(
    `api/claim_init_configs_org?organization_guid=${organizationGuid}`
  );
}

export function createOrgClaimInitConfig(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.post('api/claim_init_configs_org', payload);
}

export function updateOrgClaimInitConfig(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.put(`api/claim_init_configs_org/${guid}`, payload);
}

export function deleteOrgClaimInitConfig(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.delete(`api/claim_init_configs_org/${guid}`);
}

// ─── Org Customer Status Configs ─────────────────────────────────────────────

export function getOrgCustomerStatusConfigs(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.get(
    `api/customer_status_configs_org?organization_guid=${organizationGuid}`
  );
}

export function createOrgCustomerStatusConfig(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.post('api/customer_status_configs_org', payload);
}

export function updateOrgCustomerStatusConfig(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.put(`api/customer_status_configs_org/${guid}`, payload);
}

export function deleteOrgCustomerStatusConfig(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.delete(`api/customer_status_configs_org/${guid}`);
}

// ─── Org Claim Processing Configs ────────────────────────────────────────────

export function getOrgClaimProcConfigs(organizationGuid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.get(
    `api/claim_proc_configs_org?organization_guid=${organizationGuid}`
  );
}

export function createOrgClaimProcConfig(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.post('api/claim_proc_configs_org', payload);
}

export function updateOrgClaimProcConfig(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.put(`api/claim_proc_configs_org/${guid}`, payload);
}

export function deleteOrgClaimProcConfig(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.delete(`api/claim_proc_configs_org/${guid}`);
}

// ─── Policy Maker Checks (AML / maker-checker sequence) ───────────────────────

export function getPolicyMakerChecks() {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.get(
    `api/partners/partners_config/${getPartnerGuid()}/policy-maker-checks`
  );
}

export function createPolicyMakerCheck(payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.post(
    `api/partners/partners_config/${getPartnerGuid()}/policy-maker-checks`,
    payload
  );
}

export function updatePolicyMakerCheck(guid, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.put(
    `api/partners/partners_config/${getPartnerGuid()}/policy-maker-checks/${guid}`,
    payload
  );
}

export function deletePolicyMakerCheck(guid) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`;
  return partnerConfigsInstance.delete(
    `api/partners/partners_config/${getPartnerGuid()}/policy-maker-checks/${guid}`
  );
}
